import { hover } from "@testing-library/user-event/dist/hover";
import React from "react";
import useHover from "../hooks/useHover";

const SideCounter = ({
  image,
  counter,
  backgroundColor,
  textColor,
  hoverDescription,
  resizingBoxes,
  sizePercentage,
}) => {
  const hover = useHover(hoverDescription);
  return (
    <div {...hover.divProps} className="divColumn">
      <img
        src={image}
        style={{
          objectFit: "contain",
          width: resizingBoxes
            ? `${(20 / 100) * sizePercentage.total}px`
            : "20px",
        }}
      />
      <div
        className="textBoldWhite"
        style={{
          color: textColor,
          fontSize: resizingBoxes
            ? `${(18 / 100) * sizePercentage.total}px`
            : "18px",
        }}
      >
        {counter}
      </div>
    </div>
  );
};

export default SideCounter;
